import { LIBRARY_SORT_TYPES } from '../constants/library';

export const getLibraryRequestQueryParams = (parsedSearchParams) => {
    const queryParams = { ordering: parsedSearchParams.sort || LIBRARY_SORT_TYPES.alphabetical };
    if (parsedSearchParams.task_type) {
        queryParams.task_type = parsedSearchParams.task_type;
    }
    return queryParams;
};
